import { getHttpEndpoint, Network } from "@orbs-network/ton-access";
import { TonClient } from "ton";

let tonClient: TonClient | undefined;

export const getTonClient = async () => {
  if (tonClient) return tonClient;

  const endpoint = await getHttpEndpoint({
    network: (process.env.REACT_APP_NETWORK ?? "mainnet") as Network,
  });

  tonClient = new TonClient({ endpoint });
  return tonClient;
};
